import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const heroCategories = [
    { name: 'Pipes & Fittings', image: '/images/categories/Pipes.Fittings.png', color: 'blue', link: '#plumbing' },
    { name: 'Electrical Wires', image: '/images/categories/Electrical.Wires.png', color: 'yellow', link: '#electrical' },
    { name: 'Tools', image: '/images/categories/Tools.png', color: 'gray', link: '#products?category=tools' },
    { name: 'Lighting', image: '/images/categories/Lighting.png', color: 'orange', link: '#products?category=lighting' },
    { name: 'Bathroom', image: '/images/categories/Bathroom.png', color: 'green', link: '#products?category=bathroom' },
    { name: 'Kitchen', image: '/images/categories/Kitchen.png', color: 'red', link: '#products?category=kitchen' },
  ];

  const handleShopNow = () => {
    // Scroll to featured products section
    const featuredSection = document.getElementById('featured');
    if (featuredSection) {
      featuredSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="mt-32 bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Categories Sidebar */}
          <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="font-bold text-gray-800 mb-4">All Categories</h3>
            <div className="space-y-3">
              {heroCategories.map((category, index) => (
                <motion.a
                  key={category.name}
                  href={category.link}
                  className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 transition-colors"
                  whileHover={{ x: 5 }}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                    <img 
                      src={category.image} 
                      alt={category.name}
                      className="w-8 h-8 object-contain"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <span className="text-lg hidden">📦</span>
                  </div>
                  <span className="text-gray-700">{category.name}</span>
                </motion.a>
              ))}
            </div>
          </div>

          {/* Main Hero Banner */}
          <div className="lg:col-span-3">
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg p-8 text-white">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <h1 className="text-4xl font-bold mb-4">Quality Supplies</h1>
                <p className="text-xl mb-6">Professional plumbing & electrical equipments</p>
                <motion.button
                  className="bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors cursor-pointer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleShopNow}
                >
                  Shop Now
                </motion.button>
              </motion.div>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-4 mt-6">
              {[
                { number: '500+', label: 'Products' },
                { number: '24/7', label: 'Support' },
                { number: 'Kakamega', label: 'Delivery' }
              ].map((stat, index) => (
                <motion.div
                  key={stat.label}
                  className="bg-white rounded-lg p-4 text-center shadow-sm"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 + index * 0.1 }}
                >
                  <div className="text-lg font-bold text-gray-800">{stat.number}</div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
